import { render, staticRenderFns } from "./FuelAllocationsTab.vue?vue&type=template&id=65404252&"
import script from "./FuelAllocationsTab.vue?vue&type=script&lang=ts&"
export * from "./FuelAllocationsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports